import 'react-datepicker/dist/react-datepicker.css'

import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Form } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * id of the field
   */
  id: PropTypes.string.isRequired,
  /**
   * Name of the field
   * If no name is passed id is used as name
   */
  name: PropTypes.string,
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Value of the field
   */
  value: PropTypes.string,
  /**
   * validation errors messages
   */
  errors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Class of the container wrapper
   */
  containerClassName: PropTypes.string,
  /**
   * Class to style the title
   */
  titleClassName: PropTypes.string,
  /**
   * Class to override default control styles
   */
  className: PropTypes.string,
  /**
   * Indicates if field is required
   */
  required: PropTypes.bool,
}

function TimeField(props) {
  const {
    id,
    name = null,
    title = null,
    onChange,
    value = null,
    errors = [],
    containerClassName = '',
    titleClassName = '',
    className = '',
    required = false,
    ...rest
  } = props ?? {}

  return (
    <div className={clsx('mb-3', containerClassName)}>
      {title && (
        <p className={clsx('mb-2', titleClassName)}>
          <FormattedMessage id={title} />
          {required && <span className="font-size-regular text-color-danger">*</span>}
        </p>
      )}

      <Form.Control
        {...rest}
        type="time"
        id={id}
        name={name || id}
        value={value}
        onChange={onChange}
        className={clsx(errors?.length && 'error-border', className)}
      />

      {errors?.map((errorMessage) => (
        <div key={errorMessage} className="text-color-danger mt-2">
          {errorMessage}
        </div>
      ))}
    </div>
  )
}

TimeField.propTypes = propTypes

export default TimeField
